// semeia-disable-reexport
import type HealthCentre from "parog-web/models/health-centre";
import type Medic from "parog-web/models/medic";

export interface MedicsByHealthCentre {
  healthCentreName: string;
  healthCentre?: HealthCentre;
  medics: Medic[];
  isVisible: boolean;
}

export function getMedicsByHealthCentre(
  healthCentres: HealthCentre[]
): MedicsByHealthCentre[] {
  return healthCentres.map(healthCentre => ({
    healthCentre,
    healthCentreName: healthCentre.name,
    medics: healthCentre.medics,
    isVisible: true
  }));
}

export function sortedMedicsByHealthCentre(
  healthCentres: HealthCentre[],
  currentMedic: Medic | undefined
): MedicsByHealthCentre[] {
  const medicsByHealthCentre = getMedicsByHealthCentre(healthCentres);

  medicsByHealthCentre.forEach(medicByHc => {
    medicByHc.medics = medicByHc.medics.toSorted((m1, m2) => {
      const rolesComparison = m1.role.localeCompare(m2.role);
      const lastNameComparison = m1.lastName.localeCompare(m2.lastName);
      return rolesComparison == 0 ? lastNameComparison : rolesComparison;
    });
  });
  return medicsByHealthCentre.map(obj => {
    if (obj.healthCentre && currentMedic) {
      obj.isVisible =
        currentMedic.healthCentres.includes(obj.healthCentre) ||
        currentMedic.isSuperUser;
    }
    return obj;
  });
}
